/**
 * External dependencies
 */
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import IconAccount from '@/common/components/icon/icon-account';
import IconApple from '@/common/components/icon/icon-apple';
import IconBook from '@/common/components/icon/icon-book';
import IconCart from '@/common/components/icon/icon-cart';
import IconClipboard from '@/common/components/icon/icon-clipboard';
import IconFacebook from '@/common/components/icon/icon-facebook';
import IconGoogle from '@/common/components/icon/icon-google';
import IconHistory from '@/common/components/icon/icon-history';
import IconLock from '@/common/components/icon/icon-lock';
import IconMail from '@/common/components/icon/icon-mail';
import IconMailAlt from './icon-mail-alt';
import IconPhone from '@/common/components/icon/icon-phone';
import IconPhoneCall from '@/common/components/icon/icon-phone-call';
import IconPin from '@/common/components/icon/icon-pin';
import IconSearch from '@/common/components/icon/icon-search';
import IconShare from '@/common/components/icon/icon-share';
import IconShareAlt from '@/common/components/icon/icon-share-alt';
import IconShoppingBag from '@/common/components/icon/icon-shopping-bag';
import IconShoppingBagFilled from '@/common/components/icon/icon-shopping-bag-filled';
import IconSunny from '@/common/components/icon/icon-sun';
import IconWifi from '@/common/components/icon/icon-wifi';
import IconCalendar from '@/common/components/icon/icon-calendar';
import IconStar from '@/common/components/icon/icon-star';
import IconLocation from '@/common/components/icon/icon-location';
import IconInHouse from '@/common/components/icon/icon-inhouse';
import IconLeaf from '@/common/components/icon/icon-leaf';
import IconDiamond from '@/common/components/icon/icon-diamond';
import IconCamera from '@/common/components/icon/icon-camera';
import IconProfessional from '@/common/components/icon/icon-professional';
import IconFireworks from '@/common/components/icon/icon-fireworks';
import IconCheck from '@/common/components/icon/icon-check';
import IconStarRounded from '@/common/components/icon/icon-star-rounded';
import IconTrashcan from '@/common/components/icon/icon-trashcan';
import IconPlus from '@/common/components/icon/icon-plus';
import IconCross from '@/common/components/icon/icon-cross';
import IconMinus from '@/common/components/icon/icon-minus';
import IconSettings from '@/common/components/icon/icon-settings';
import IconBell from '@/common/components/icon/icon-bell';
import IconBurger from '@/common/components/icon/icon-burger';
import IconHouse from '@/common/components/icon/icon-house';
import IconLogout from '@/common/components/icon/icon-logout';
import IconPen from '@/common/components/icon/icon-pen';
import IconBed from '@/common/components/icon/icon-bed';
import IconToilet from '@/common/components/icon/icon-toilet';
import IconHome from '@/common/components/icon/icon-home';
import IconEdit from '@/common/components/icon/icon-edit';
import IconReceptionBell from '@/common/components/icon/icon-reception-bell';
import IconStarGrey from '../../../assets/svg-icons/icon-star-grey';
import IconReorder from '@/common/components/icon/icon-reorder';
import IconLink from './icon-link';
import IconCircleX from './icon-circle-x';

const availableIcons = {
    'account': IconAccount,
    'apple': IconApple,
    'book': IconBook,
    'cart': IconCart,
    'clipboard': IconClipboard,
    'facebook': IconFacebook,
    'google': IconGoogle,
    'history': IconHistory,
    'lock': IconLock,
    'mail': IconMail,
    'phone-call': IconPhoneCall,
    'phone': IconPhone,
    'pin': IconPin,
    'search': IconSearch,
    'share': IconShare,
    'share-alt': IconShareAlt,
    'shopping-bag': IconShoppingBag,
    'shopping-bag-filled': IconShoppingBagFilled,
    'sunny': IconSunny,
    'wifi': IconWifi,
    'calendar': IconCalendar,
    'star': IconStar,
    'location': IconLocation,
    'inHouse': IconInHouse,
    'house': IconHouse,
    'leaf': IconLeaf,
    'diamond': IconDiamond,
    'camera': IconCamera,
    'professional': IconProfessional,
    'fireworks': IconFireworks,
    'check': IconCheck,
    'star-rounded': IconStarRounded,
    'icon-trashcan': IconTrashcan,
    'plus': IconPlus,
    'cross': IconCross,
    'minus': IconMinus,
    'settings': IconSettings,
    'bell': IconBell,
    'burger': IconBurger,
    'logout': IconLogout,
    'pen': IconPen,
    'bed': IconBed,
    'toilet': IconToilet,
    'home': IconHome,
    'edit': IconEdit,
    'reception-bell': IconReceptionBell,
    'star-grey': IconStarGrey,
    'reorder': IconReorder,
    'link': IconLink,
    'mail-alt': IconMailAlt,
    'circle-x': IconCircleX,
};

const Icon = ({ size = 15, className = '', color = 'currentColor', ...props }) => {
    const { name } = props;
    const TheIcon = availableIcons[name];

    if (!TheIcon) throw new Error(`${name} is not a valid icon name`);

    return (
        <TheIcon
            size={size}
            color={color}
            className={classNames(`icon icon--${name}`, {
                [className]: className,
            })}
            {...props}
        />
    );
};

export default Icon;
